import avayaCustomized from './avayaCustomized';

export default avayaCustomized;
